/**
 * Copyright (c) 2017 ~ present NAVER Corp.
 * billboard.js project is licensed under the MIT license
 */
/**
 * CSS class names definition
 * @private
 */
export default {
	arc: "bb-arc",
	arcs: "bb-arcs",
	area: "bb-area",
	areas: "bb-areas",
	axis: "bb-axis",
	axisX: "bb-axis-x",
	axisXLabel: "bb-axis-x-label",
	axisY: "bb-axis-y",
	axisY2: "bb-axis-y2",
	axisY2Label: "bb-axis-y2-label",
	axisYLabel: "bb-axis-y-label",
	bar: "bb-bar",
	bars: "bb-bars",
	brush: "bb-brush",
	button: "bb-button",
	buttonZoomReset: "bb-zoom-reset",
	chart: "bb-chart",
	chartArc: "bb-chart-arc",
	chartArcs: "bb-chart-arcs",
	chartArcsBackground: "bb-chart-arcs-background",
	chartArcsGaugeMax: "bb-chart-arcs-gauge-max",
	chartArcsGaugeMin: "bb-chart-arcs-gauge-min",
	chartArcsGaugeUnit: "bb-chart-arcs-gauge-unit",
	chartArcsTitle: "bb-chart-arcs-title",
	chartArcsGaugeTitle: "bb-chart-arcs-gauge-title",
	chartBar: "bb-chart-bar",
	chartBars: "bb-chart-bars",
	chartLine: "bb-chart-line",
	chartLines: "bb-chart-lines",
	chartRadar: "bb-chart-radar",
	chartRadars: "bb-chart-radars",
	chartText: "bb-chart-text",
	chartTexts: "bb-chart-texts",
	circle: "bb-circle",
	circles: "bb-circles",
	colorPattern: "bb-color-pattern",
	colorScale: "bb-colorscale",
	defocused: "bb-defocused",
	dragarea: "bb-dragarea",
	empty: "bb-empty",
	eventRect: "bb-event-rect",
	eventRects: "bb-event-rects",
	eventRectsMultiple: "bb-event-rects-multiple",
	eventRectsSingle: "bb-event-rects-single",
	focused: "bb-focused",
	gaugeValue: "bb-gauge-value",
	grid: "bb-grid",
	gridLines: "bb-grid-lines",
	legendBackground: "bb-legend-background",
	legendItem: "bb-legend-item",
	legendItemEvent: "bb-legend-item-event",
	legendItemFocused: "bb-legend-item-focused",
	legendItemHidden: "bb-legend-item-hidden",
	legendItemPoint: "bb-legend-item-point",
	legendItemTile: "bb-legend-item-tile",
	level: "bb-level",
	levels: "bb-levels",
	line: "bb-line",
	lines: "bb-lines",
	region: "bb-region",
	regions: "bb-regions",
	selectedCircle: "bb-selected-circle",
	selectedCircles: "bb-selected-circles",
	shape: "bb-shape",
	shapes: "bb-shapes",
	stanfordElements: "bb-stanford-elements",
	stanfordLine: "bb-stanford-line",
	stanfordLines: "bb-stanford-lines",
	stanfordRegion: "bb-stanford-region",
	stanfordRegions: "bb-stanford-regions",
	target: "bb-target",
	text: "bb-text",
	texts: "bb-texts",
	title: "bb-title",
	tooltip: "bb-tooltip",
	tooltipContainer: "bb-tooltip-container",
	tooltipName: "bb-tooltip-name",
	xgrid: "bb-xgrid",
	xgridFocus: "bb-xgrid-focus",
	xgridLine: "bb-xgrid-line",
	xgridLines: "bb-xgrid-lines",
	xgrids: "bb-xgrids",
	ygrid: "bb-ygrid",
	ygridLine: "bb-ygrid-line",
	ygridLines: "bb-ygrid-lines",
	ygrids: "bb-ygrids",
	zoomBrush: "bb-zoom-brush",
	zoomRect: "bb-zoom-rect",
	EXPANDED: "_expanded_",
	SELECTED: "_selected_",
	INCLUDED: "_included_"
};
